// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const SVGWrapperContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
//# sourceMappingURL=style.js.map